export default __webpack_public_path__ + "static/media/FOURSQUARE.05cfc3b4.png";